<template>
  <div class="area-selection-mobile">
    <div class="loading-container" v-if="imgLoading">
      <mcr-loading-indicator :loading="true"></mcr-loading-indicator>
    </div>
    <div class="cropper-wrapper" :class="{loaded: !imgLoading}">
      <cropper
        class="cropper"
        ref="cropper"
        :src="src"
        :min-width="120"
        :canvas="false"
        @change="onChange"
        @ready="onImageLoaded"
      />
    </div>
  </div>
</template>

<script>
import {Cropper} from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';

export default {
  props: {
    src: String,
  },
  data() {
    return {
      croppa: {},
      imgLoading: true,
      coordinates: null,

      imageWidth: 0,
      imageHeight: 0,
      imageScale: 1,
    };
  },
  methods: {
    onChange({coordinates, image, imageTransforms}) {
      this.coordinates = coordinates;
      this.imageWidth = imageTransforms && imageTransforms.rotate === 90 ? image.height : image.width;
      this.imageHeight = imageTransforms && imageTransforms.rotate === 90 ? image.width : image.height;
      this.imageScale = 1;

      const x1 = this.coordinates.left;
      const y1 = this.coordinates.top;
      const x2 = this.coordinates.left + this.coordinates.width;
      const y2 = this.coordinates.top + this.coordinates.height;
      this.$emit('change', {x1, y1, x2, y2, imageWidth: this.imageWidth, imageHeight: this.imageHeight});
    },
    onImageLoaded(data) {
      this.imgLoading = false;
    },
  },
  name: 'AreaSelectionMobile',
  components: {Cropper},
};
</script>

<style scoped lang="scss">
.area-selection-mobile {
  max-width: 800px;
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px 0;

  box-sizing: border-box;
  .cropper-wrapper,
  .loading-container {
    height: 400px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .cropper-wrapper.loaded {
    background: black;
  }

  .loading-container {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    left: 0;
    right: 0;

    .mcr-loading-indicator {
      margin: 0;
    }
  }

  @media only screen and (min-width: $breakpoint-phablet) {
    .cropper-wrapper {
      width: 500px;
    }
  }
}
</style>
